/* This file was automatically generated - please modify the template not this file! */

import { AppState } from "./model";
import { customerDocumentSelector } from "./selectors";
import { detailRoutes } from "./detailRoutes";

const detailRoute = () => ({
    "/:customerDocumentId": {
        title: (state: AppState) => customerDocumentSelector(state).name || "Customer Document",
        "/edit": {
            title: "Edit",
        },
        ...detailRoutes
    }
});

export const routes = {
    "/customerDocuments": {
        title: "CustomerDocuments",
        ...detailRoute(),
        "/create": {
            title: "Create Customer Document"
        }
    }
};

export const childRoutes =
    (titleFunc: (state: any) => string) => {
        return {
            "/customerDocuments": {
                title: (state: AppState) => titleFunc(state) ? titleFunc(state) + " Customer Documents": "Customer Documents",
                ...detailRoute(),
                "/create": {
                    title: "Create Customer Document",
                }
            }
        };
    };
